module.exports = __webpack_public_path__ + "img/step4-dark.dd614c80.png";